import { Box, LinearProgress } from "@mui/material";
import { TablePlaceholder } from "../../components/TablePlaceholder";
import { useLocale } from "../../providers/LocaleProvider";
import CheckListIcon from "../../resources/images/icons-checklist.svg";
import { KLAYO_COLORS } from "../../themes";

export interface JobBenchmarkingProgressProps {
  isLoading: boolean;
}

const JobBenchmarkingProgress = ({ isLoading }: JobBenchmarkingProgressProps) => {
  const { translate } = useLocale();

  return (
    <Box
      height='100%'
      width='100%'
      sx={{
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2
          }}
        >
          <LinearProgress
            sx={{
              width: "90%",
              backgroundColor: KLAYO_COLORS.GreyGR100,
              height: 8,
              borderRadius: 4,
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#6366F1",
                borderRadius: 4
              }
            }}
          />

          <div className='klayo-placeholder_text_secondary'>
            {translate("settingsViews.jobBenchmarking.benchmarkingInProgress")}
          </div>
        </Box>
      ) : (
        <TablePlaceholder
          text={translate("settingsViews.jobBenchmarking.selectKlayoIntelligenceJob")}
          icon={<CheckListIcon />}
          sx={{
            background: "transparent"
          }}
        />
      )}
    </Box>
  );
};

export default JobBenchmarkingProgress;
